import { useNavigate } from 'react-router-dom';
import './BCrateCard.css';

interface BCrateCardProps {
  reportId: string;
  title: string;
  description?: string;
  genreTags?: string[];
  era?: string;
  location?: string;
  number?: number;
  size?: 'small' | 'medium' | 'large';
  onTagClick?: (tag: string) => void;
}

/**
 * Report preview card for the crate grid.
 * Shows title, description, genre tags, and meta info.
 */
export function BCrateCard({
  reportId,
  title,
  description,
  genreTags = [],
  era,
  location,
  number,
  size = 'medium',
  onTagClick,
}: BCrateCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/b/report/${reportId}`);
  };

  const handleTagClick = (e: React.MouseEvent, tag: string) => {
    e.stopPropagation();
    onTagClick?.(tag);
  };

  return (
    <article
      className={`b-crate-card b-crate-card--${size}`}
      onClick={handleClick}
    >
      {number !== undefined && (
        <span className="b-crate-card__number">
          {String(number).padStart(2, '0')}
        </span>
      )}

      <div className="b-crate-card__content">
        <h3 className="b-crate-card__title">{title}</h3>

        {description && (
          <p className="b-crate-card__desc">{description}</p>
        )}

        {genreTags.length > 0 && (
          <div className="b-crate-card__tags">
            {genreTags.slice(0, 3).map(tag => (
              <button
                key={tag}
                className="b-crate-card__tag"
                onClick={(e) => handleTagClick(e, tag)}
              >
                {tag}
              </button>
            ))}
          </div>
        )}

        {(era || location) && (
          <div className="b-crate-card__meta">
            <span className="b-crate-card__info">
              {era}
              {era && location && ' · '}
              {location}
            </span>
          </div>
        )}
      </div>
    </article>
  );
}
